import { FC, ReactNode } from 'react'
import s from './ContainerTwoColumns.module.sass'
import { BlockBoundary } from '../../../../lib/components/BlockBoundary'

interface Props {
  children: ReactNode
  className?: string
}

type ComponentExtensions = {
  Main: typeof ContainerTwoColumnsMain
  Aside: typeof ContainerTwoColumnsAside
}

const ContainerTwoColumnsMain: FC<
  Props & React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>
> = ({ children, className = '', ...props }) => {
  return (
    <main className={`${s.main} ${className}`} {...props}>
      {children}
    </main>
  )
}

const ContainerTwoColumnsAside: FC<
  Props & React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>
> = ({ children, className = '', ...props }) => {
  return (
    <aside className={`${s.aside} ${className}`} {...props}>
      {children}
    </aside>
  )
}

const ContainerTwoColumns: FC<Props & React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>> &
  ComponentExtensions = ({ children, className = '', ...props }) => {
  return (
    <BlockBoundary>
      <div className={`${s.container} ${className}`} {...props}>
        {children}
      </div>
    </BlockBoundary>
  )
}

ContainerTwoColumns.Main = ContainerTwoColumnsMain
ContainerTwoColumns.Aside = ContainerTwoColumnsAside

export default ContainerTwoColumns
